import apiClient from './apiClient';

const normalizeEvent = (e) => ({ ...e, severity: String(e?.severity || 'MEDIUM').toLowerCase(), status: String(e?.status || 'NEW').toLowerCase() });

export async function fetchThreatMonitoringEvents() {
  const { data } = await apiClient.get('/threat-monitoring/events');
  return data.map(normalizeEvent);
}

export async function setThreatEventStatus(id, status) {
  const { data } = await apiClient.patch(`/threat-monitoring/events/${id}/status`, { status });
  return normalizeEvent(data);
}
